import { render } from "./TabelaDetalheTransferencia.vue?vue&type=template&id=94b6d1ae&scoped=true"
import script from "./TabelaDetalheTransferencia.vue?vue&type=script&lang=js"
export * from "./TabelaDetalheTransferencia.vue?vue&type=script&lang=js"

import "./TabelaDetalheTransferencia.vue?vue&type=style&index=0&id=94b6d1ae&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94b6d1ae"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QTooltip,QInput,QSelect,QPopupProxy,QDate,QBtn,QTabs,QTab,QLinearProgress,QTable,QCard,QTr,QTh,QTd,QPagination,QRadio,QImg,QScrollArea,QCheckbox,QSeparator,QDialog,QCardSection});qInstall(script, 'directives', {ClosePopup});
